import { useEffect, useState } from "react"
import Alert from "../../components/alert";
import Badge from "../../components/badge";
import Card from "../../components/card";
import { useLayoutContext } from "../../context/game"
import { useLightboxContext } from "../../context/lightbox";
import './question.scss';

export default function Questions({setRoute,count}){
	const [context,setContext] = useLayoutContext();
	const [lightbox, setLightbox] = useLightboxContext();
	useEffect(()=>{
		setContext({
			hasStarted:true,
		});
	},[])
	const searchParams = new URLSearchParams(window.location.search);
	const previewQuestion = searchParams.get('current') || window['current'];
	let qIndex = previewQuestion ? parseInt(previewQuestion) - 1 : 0;
	const questionIds = Object.keys(window.game_data?.questions || {});
	const [questionList, setQuestionList] = useState(questionIds);
	const firstQuestionId = questionList[qIndex] || null;
	const game_questions = window.game_data?.questions || {};
	const game_options = window.game_data?.options || {};
	const game_answers = window.game_data?.answers || {};
	const [question,setQuestion] = useState(game_questions[firstQuestionId]);
	const [options, setOptions] = useState(game_options[firstQuestionId]);
	const [correct, setCorrect] = useState(game_answers[firstQuestionId]);
	const [isCorrect, setIsCorrect] = useState(null);
	const [answered, setAnswered] = useState(null);
	const [selected, setSelected] = useState(null);
	const [answeredList,setAnsweredList] = useState({});
	const questionNumberInitial = qIndex != null ? qIndex + 1 : count - questionList.length + 1;
	const [questionNumber, setQuestionNumber] = useState(questionNumberInitial);
	useEffect(()=>{
		if(!selected) return;

		const isCorrectAnswer = answered === correct;
		setIsCorrect(isCorrectAnswer);

	},[selected])

	useEffect(()=>{
		if(answered === null) return;
		
		setTimeout(()=>{
			if (qIndex != null){
				const done = questionList.shift()
				setAnsweredList({
					...answeredList,
					[done]:answered
				});
				setQuestionList(questionList);
				const disabled = [...context.disabled, done];
				setContext({disabled});
			}
			setAnswered(null);
			setSelected(null);
			setIsCorrect(null);
			setQuestionNumber(questionNumber + 1);
		},3000)
	},[answered])

	useEffect(()=>{
		if(!questionIds.length) return;
		if(qIndex) return;
		const questionId = questionList[0];
		if(!questionId){
			setContext({answeredList,hasStarted:false});
			setRoute('title');
			return;
		}

		setQuestion(game_questions[questionId]);
		setOptions(game_options[questionId]);
		setCorrect(game_answers[questionId]);
	},[questionList.length])

	useEffect(()=>{
		if(context?.disabled.length === 0){
			setQuestionList(Object.keys(window.game_data?.questions || {}))
			setQuestionNumber(1);
		}
	},[context?.disabled?.length])
	if(questionIds.length === 0){
		return (
			<div className="row g-0 px-3">
				<div className="col-xl-6 col-lg-8 mx-auto py-5">
					<Card className="align-items-center">
						<svg className='mb-4' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="72" height="72"><path fill="none" d="M0 0h24v24H0z" /><path fill='#F5B736' d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" /></svg>
						<h2>Žaidimo peržiūra bus sugeneruota kai užpildysite bent vieną įrašą.</h2>
					</Card>
				</div>
			</div>
		)
	}
	return(
		<div className="position-relative py-5 flex-grow-1">
			<div className="game-bg"></div>
			<div className="question-wrap px-3">
				<div className="row">
					<div className="col-xl-6 col-lg-7 mx-auto pt-3">
						<Card className="p-0">
							<div className="px-4 px-md-5 pt-4 pb-5 mt-5">
								<div style={{marginTop:-45, marginBottom:16}}>
									<Badge className="fw-600 heads mt-0">
										Klausimas {questionNumber} iš {count}
									</Badge>
								</div>
								<div className="question-text mb-4 mt-3 py-3">{question?.text}</div>
								{question?.img && (
									<div className="question-img-wrap mt-4 mb-5">
										<img src={question.img} onClick={()=>{setLightbox(question.img)}} alt={question.text} className="question-img" />
									</div>
								)}
								<div className="quiz-option-wrap row g-3 justify-content-center">
									{options && Object.keys(options).map((id)=>{
										const label = options[id];
										const isSelected = id === selected;
										return (
											<div key={id} className="col-lg-6">
												{/* <div onClick={()=>{setSelected(isSelected?null:id)}} className={`shadow-custom quiz-option quiz-option--hover${isSelected ? ' quiz-option--selected' : ''}`}> */}
												<div 
													onClick={()=>{
														const isCorrectAnswer = id === correct;
														setIsCorrect(isCorrectAnswer);
														setAnswered(id)
													}} 
													className={`shadow-custom quiz-option quiz-option--hover${isSelected ? ' quiz-option--selected' : ''}`}
												>
													{label}
												</div>
											</div>
										)
									})}
								</div>
							</div>
							{selected && (
								<button onClick={()=>{setAnswered(selected)}} className="question-confirm-btn" style={{width:'100%'}}>
									Patvirtinti
								</button>
							)}
			
						</Card>
					</div>
				</div>
				{answered && (<AlertWrap
					isCorrect={isCorrect}
					correct={correct}
					selected={selected}
				/>)}
			</div>
		</div>
	)
}

function AlertWrap({isCorrect,correct,selected}){

	return(
		<div className="question-alert-wrap">
			<Alert isCorrect={isCorrect} />
		</div>
	)
}